// import "@babel/polyfill"
import Vue from 'vue'
import global_mixin from './global_mixins.js'
import LazyBackground from '../components/LazyBackground.vue'
import '../css/index.css'
var _ = require('lodash')
import gql from 'graphql-tag'
import VueGallery from '../components/Gallery.vue'
/*var lightGallery = require('lightgallery.js')*/
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lg-video.js'
import { Base64 } from 'js-base64'
Vue.component('lazy-background', LazyBackground)

const app = new Vue({
  el: '#app',
  components: {
    gallery: VueGallery
  },
  mixins: [global_mixin],
  data () {
    return {
      currentSlide: 0,
      seriesData: {},
      initialDataLoaded: false,
      currentSeriesID: 0,
      slideDirection: 'right',
      showGallery: false,
      isTransitioningSeries: false,
      polaroidLeft: 0,
      polaroidRight: 4,
      polaroids: [],
      currentVideo: '',
      polaroidDisplayLimit: 4,
      lightboxIndex: null,
      lightboxKey:
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15),
      initialSeries: {},
      allSeriesScenes: {},
      polaroidsOffset: 0
    }
  },
  mounted () {
    this.initialSeries = JSON.parse(
      JSON.parse(document.getElementById('initial_slider_series').textContent)
    )
    this.allSeriesScenes = JSON.parse(
      JSON.parse(document.getElementById('slider_scenes').textContent)
    )
    setInterval(() => {
      if (!this.stopSlider) {
        this.nextSeries()
      }
    }, 7000)
  },
  methods: {
    setSlideDirectionLeft () {
      this.slideDirection = 'left'
      setTimeout(() => {
        this.slideDirection = 'right'
      }, 2500)
    },
    changeSlide (index, series) {
      if (this.seriesIndex > index) {
        this.setSlideDirectionLeft()
      } else {
        this.slideDirection = 'right'
      }
      this.currentSeriesID = series
      this.polaroidsOffset = 0
      // if(Base64.decode(series).includes("SeriesGraph")){
      //   this.polaroidsActive = true
      // } else {
      //   this.polaroidsActive = false
      // }
      //this.currentSlide = index
    },
    previousSeries () {
      this.setSlideDirectionLeft()
      this.polaroidsOffset = 0
      if (this.seriesIndex > 0 && this.initialSeriesIDs.length) {
        //        this.seriesIndex = this.seriesIndex - 1
        this.currentSeriesID = this.initialSeriesIDs[this.seriesIndex - 1]
      }
    },
    nextSeries () {
      let slide_length_offset = this.initialSeriesIDs.length - 1
      this.polaroidsOffset = 0
      if (
        this.seriesIndex < slide_length_offset &&
        this.initialSeriesIDs.length
      ) {
        //        this.seriesIndex = this.seriesIndex + 1
        this.currentSeriesID = this.initialSeriesIDs[this.seriesIndex + 1]
      } else if (
        this.seriesIndex === slide_length_offset &&
        this.initialSeriesIDs.length
      ) {
        //        this.seriesIndex = 0
        this.currentSeriesID = this.initialSeriesIDs[0]
      }
    },
    previousPolaroid () {
      let slide_length_offset = this.currentSeriesSlides.length - 1
      this.polaroidsOffset--
      // let previousPolaroid = this.currentSeriesPolaroids.pop()
      // this.currentSeriesPolaroids.unshift(previousPolaroid)
    },
    nextPolaroid () {
      let slide_length_offset = this.currentSeriesSlides.length - 1
      this.polaroidsOffset++
      // let previousPolaroid = this.currentSeriesPolaroids.shift()
      // this.currentSeriesPolaroids.push(previousPolaroid)
    },
    getTiles (scene) {
      let data = ''
      for (const tiles of scene.tiles.edges) {
        data = data + tiles.node.sku + ', '
      }
      data = data.substring(0, data.length - 2)
      return data
    },
    getSizes (scene) {
      let data = ''
      for (const tiles of scene.tiles.edges) {
        data = data + tiles.node.shape.size + ', '
      }
      data = data.substring(0, data.length - 2)
      return data
    },
    lightingGallery (index) {
      let el = document.getElementById('lightgallery')
      if (el.getAttribute('lg-uid')) {
        window.lgData[el.getAttribute('lg-uid')].destroy(true)
      }

      window.lightGallery(el, {
        mode: 'lg-fade',
        autoplayFirstVideo: true,
        dynamic: true,
        dynamicEl: this.lightboxContent,
        fullScreen: false
      })
      window.lgData[el.getAttribute('lg-uid')].index = index
      window.lgData[el.getAttribute('lg-uid')].slide(index)
    }
  },
  computed: {
    currentSeriesScenes () {
      let scenes = []
      if (this.allSeriesScenes && this.currentSeriesID) {
        scenes = _.filter(this.allSeriesScenes.edges, scene => {
          return scene.node.series.id == this.currentSeriesID
        })
        scenes = scenes.reverse()
      }
      return scenes
    },
    mainSliderImage () {
      let slider = {}
      if (this.lightboxContent) {
        slider = _.find(this.lightboxContent, o => {
          return o.sliderImage
        })
      }
      return slider
    },
    currentSeriesPolaroids () {
      let polaroids = []
      if (
        this.polaroidsActive &&
        this.currentSeriesID &&
        this.currentSeriesScenes
      ) {
        if (
          this.currentSeriesScenes[0] &&
          this.currentSeriesScenes[0].node.series.videoEmbedUrl != ''
        ) {
          let href = this.currentSeriesScenes[0].node.series.videoEmbedUrl
          let youtubeID = href.split('embed/')
          polaroids.push({
            href: this.currentSeriesScenes[0].node.series.videoEmbedUrl,
            thumbnail:
              'https://img.youtube.com/vi/' + youtubeID[1] + '/default.jpg',
            id: 'dsafdsfdsafdfdfrfafafadfsf'
          })
        }

        for (const slide of this.currentSeriesScenes) {
          polaroids.push(slide.node)
        }
        if (this.polaroidsOffset > 0) {
          for (let i = 0; i < this.polaroidsOffset; i++) {
            let previousPolaroid = polaroids.shift()
            polaroids.push(previousPolaroid)
          }
        } else if (this.polaroidsOffset < 0) {
          for (let i = 0; i > this.polaroidsOffset; i--) {
            let previousPolaroid = polaroids.pop()
            polaroids.unshift(previousPolaroid)
          }
        }
      }
      return polaroids
    },
    polaroidsActive () {
      let active = false
      if (this.currentSeriesID) {
        if (!Base64.decode(this.currentSeriesID).includes('SeriesGraph')) {
          active = false
        } else {
          active = true
        }
      }
      return active
    },
    seriesIndex () {
      let index = 0
      if (this.initialSeriesIDs && this.initialSeriesIDs.length) {
        index = this.initialSeriesIDs.indexOf(this.currentSeriesID)
      }
      return index
    },
    currentSeriesSlides () {
      let slides = []

      if (this.currentSeriesScenes && this.currentSeriesScenes.edges) {
        for (const scene of this.currentSeriesScenes.edges) {
          slides.push(scene.node)
        }
        for (const scene of this.initialSeries.edges[0].node.additionalScenes
          .edges) {
          slides.push(scene.node)
        }
      }
      return slides
    },
    currentSeriesData () {
      let data = {}
      if (this.currentSeriesID !== 0 && this.initialSeries) {
        if (Base64.decode(this.currentSeriesID).includes('SeriesGraph')) {
          data = _.find(this.initialSeries.edges, o => {
            return o.node.id === this.currentSeriesID
          }).node
          data['sliderImage'] = _.filter(this.currentSeriesScenes, scene => {
            return scene.node.sliderImage
          })[0].node.sliderImage
        } else {
          data = _.find(
            this.initialSeries.edges[0].node.additionalScenes.edges,
            o => {
              return o.node.id === this.currentSeriesID
            }
          ).node
        }
      }
      return data
    },
    initialSeriesID () {
      let id = null
      if (this.initialSeriesIDs.length > 0) {
        id = this.initialSeriesIDs[0]
      }
      return id
    },
    initialSeriesIDs () {
      let ids = []
      if (this.initialSeries && this.initialSeries.edges) {
        // Removed to disallow Series in slider
        // for (const id of this.initialSeries.edges) {
        //   if (id.node) {
        //     ids.push(id.node.id)
        //   }
        // }
        if(this.initialSeries.edges.length){
          for (const id of this.initialSeries.edges[0].node.additionalScenes
            .edges) {
            if (id.node) {
              ids.unshift(id.node.id)
            }
          }
        }
        
      }
      return ids
    },
    lightboxContent () {
      let data = []
      if (this.currentSeriesPolaroids) {
        for (const element of this.currentSeriesPolaroids) {
          if (element.href) {
            let youtubeID = element.href.split('embed/')
            data.push({
              image: 'img.youtube.com/vi/' + youtubeID[1] + '/0.jpg',
              src: element.href,
              type: 'text/html',
              iframe: true,
              youtube: youtubeID[1]
            })
          } else {
            data.push({
              image: element.largeImage,
              subHtml:
                element.lightboxDescription +
                'SKU: ' +
                this.getTiles(element) +
                '<br /> ' +
                'Sizes: ' +
                this.getSizes(element),
              src: element.largeImage,
              sliderImage: element.sliderImage
            })
          }
        }
      }
      return data
    }
  },
  watch: {
    initialSeriesID (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== undefined) {
        this.currentSeriesID = newVal
      }
    },
    windowData: {
      handler: function (val, oldVal) {
        if (this.windowData.width <= 991) {
          if (this.windowData.width <= 767) {
            this.polaroidDisplayLimit = 2
          } else {
            this.polaroidDisplayLimit = 3
          }
        } else {
          this.polaroidDisplayLimit = 4
        }
        this.polaroidLeft = 0
        this.polaroidRight = this.polaroidDisplayLimit - 1
      },
      immediate: true,
      deep: true
    }
  }
})



// WEBPACK FOOTER //
// ./core/vue/js/index.js